module.exports = __webpack_public_path__ + "static/media/WinterborneHome2Jacket.1d454dd1.jpg";